import { getProductionHost } from "@/common/functions/networkUtils";

/**
 * The prefered protocol for external YDR links. Use "http:", "https:", or ""
 * as valid values. Empty string will make links protocol agnostic
 */
export const YDR_PROTOCOL = "";

/**
 * The prefered protocol for internal absolute WF links.
 * Use "http:", "https:", or "" as valid values. Empty string will make links
 * protocol agnostic
 */
export const WF_PROTOCOL = "";

/**
 * The prefered protocol to be used for canonical meta tags
 */
export const CANONICAL_PROTOCOL = "https:";

/**
 * YDR's URL, as used in About App page, e.g.
 */
export const YDR_URL = `${YDR_PROTOCOL}//www.yourdictionary.com`;

/**
 * URL for Unscrambler Service. It's taken from process environment variables
 */
export const API_SERVICE = process.env.API_SERVICE;
export const API_SERVICE_AUTH = process.env.API_SERVICE_AUTH;

export const SAVEDWORDS_KEYNAME = "saved-words";

export const DICTIONARY_KEYNAME = "selected-dictionary";

export const DEFAULTWORDS_COOKIENAME = "defaultWordsRemoved";

/**
 * Minimum amount of time in milliseconds between versionService calls.
 */
export const VERSION_CHECK_POLL_FREQ = 30000;

export const VERSION_CHECK_ERROR = "VersionError";

/**
 * The prefered host name for canonical meta tags
 */
export const CANONICAL_HOST = getProductionHost();

/**
 * The event name for translations ready state
 */
export const TRANSLATIONS_READY = "translations-ready-event";

/**
 * The values for newsletters subscription
 */
export const NEWSLETTERS = {
	ON: "subscribed",
	OFF: "unsubscribed",
};
